import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function TrafficTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin") || pathname.startsWith("/staff")) return;
    api.post("/track", { path: pathname }).catch(() => {});
  }, [pathname]);
  return null;
}
